import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f6f3dff6558f0014ed150e_1781686270321_ca2b1ad8/dvtmminutes/src/app/page.tsx");
